<template>
  <div class="flex ">
    <div v-if="params.data.welcomeEmail.length > 0" class="leading-normal">
      <p>{{ params.data.welcomeEmail.length }} {{ params.data.welcomeEmail.length == 1 ? 'vez' : 'veces' }} </p>
      <p>
        Último: {{ params.data.welcomeEmail.slice(-1)[0].sending_date | formato_fecha3}}
      </p>
       
    </div>
  </div>
    
</template>

<script>
export default {
  name: 'CellRendererWelcomeEmail',
  methods: {
  }
}
</script>
